import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useScrollToTop } from "../hooks/useScroll";

export const HeaderComponent = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const {
    scrolledTop,
    handleScrollToTop,
    setAlReadyScolled,
    setScrolledTop,
  } = useScrollToTop(200);

  const isTransparent = pathname === "/" && !scrolledTop && !menuOpen;

  const handleNavigation = () => {
    setMenuOpen(false);
    handleScrollToTop();
    setAlReadyScolled(false);
    setScrolledTop(false);
  };

  const linkClass = ({ isActive }) =>
    isActive
      ? "link-active"
      : `transition-colors duration-300 ${isTransparent ? "text-white" : "text-[#71848b]"}`;

  return (
    <header
      className={`w-full h-[70px] lg:h-[80px] lg:px-[10%] px-[30px] fixed top-0 left-0 right-0 flex items-center z-[101] transition-all duration-300 ${
        isTransparent
          ? "bg-transparent"
          : "bg-[rgba(255,255,255,0.97)] backdrop-blur-sm"
      }`}
    >
      <div className="flex w-full items-center">
        {/* Logo — left */}
        <a href="/" className="flex items-center flex-shrink-0">
          <img
            className="h-[35px] lg:h-[38px]"
            alt="Plnify Logo"
            src="/plnify_logo.png"
          />
        </a>

        {/* Desktop nav — centered */}
        <nav className="hidden lg:flex flex-1 justify-center items-center">
          <ul className="flex items-center gap-[60px] text-[1rem] [font-family:'Montserrat',Helvetica] font-medium">
            <li><NavLink to="/plans" className={linkClass} onClick={handleNavigation}>Pricing</NavLink></li>
            <li><NavLink to="/download" className={linkClass} onClick={handleNavigation}>Download</NavLink></li>
            <li><NavLink to="/faq" className={linkClass} onClick={handleNavigation}>FAQ</NavLink></li>
            <li><NavLink to="/privacy-policy" className={linkClass} onClick={handleNavigation}>Privacy Policy</NavLink></li>
          </ul>
        </nav>

        {/* Get started button — right */}
        <NavLink
          to="https://web.plnify.com/"
          target="_blank"
          className="hidden lg:inline-flex flex-shrink-0 items-center justify-center w-[140px] h-[46px] rounded-[14px] text-white font-semibold text-[1rem] [font-family:'Poppins',Helvetica] custom-btn primary"
        >
          Get started
        </NavLink>

        {/* Mobile hamburger */}
        <div
          className={`flex lg:hidden menu-san-btn z-[102] ml-auto ${menuOpen ? "activated" : ""}`}
          onClick={() => setMenuOpen((p) => !p)}
        >
          <div className="mc-bar-1 bg-[rgb(57,198,223)]"></div>
          <div className="mc-bar-2 bg-[rgb(57,198,223)]"></div>
          <div className="mc-bar-3 bg-[rgb(57,198,223)]"></div>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      <div
        className={`lg:hidden absolute top-[70px] left-0 right-0 bg-white shadow-xl flex flex-col items-center gap-6 overflow-hidden transition-all duration-300 ${
          menuOpen ? "max-h-[400px] py-8" : "max-h-0 py-0"
        }`}
      >
        <ul className="flex flex-col items-center gap-6 text-[1rem] [font-family:'Montserrat',Helvetica] font-medium text-[#71848b]">
          <li><NavLink to="/plans" className={({ isActive }) => isActive ? "link-active" : ""} onClick={handleNavigation}>Pricing</NavLink></li>
          <li><NavLink to="/download" className={({ isActive }) => isActive ? "link-active" : ""} onClick={handleNavigation}>Download</NavLink></li>
          <li><NavLink to="/faq" className={({ isActive }) => isActive ? "link-active" : ""} onClick={handleNavigation}>FAQ</NavLink></li>
          <li><NavLink to="/privacy-policy" className={({ isActive }) => isActive ? "link-active" : ""} onClick={handleNavigation}>Privacy Policy</NavLink></li>
        </ul>
        <NavLink
          to="https://web.plnify.com/"
          target="_blank"
          className="inline-flex items-center justify-center w-[80%] h-[50px] rounded-[14px] text-white font-semibold text-[1rem] [font-family:'Poppins',Helvetica] custom-btn primary"
          onClick={() => setMenuOpen(false)}
        >
          Get started
        </NavLink>
      </div>
    </header>
  );
};
